import { useSearchParams } from "react-router-dom";

/**
 * เว็บต้นทางที่ให้โชว์โลโก้ร่วม "แบ่งเบา ✕ SME อวดดี"
 * — มาจากปุ่ม "ล็อคอิน" หน้า https://auaddee.com/business ซึ่งห้อย ?from=msme มาให้
 */
const CO_BRAND_SITES = ["msme", "auaddee"];

/**
 * ตัดสินจาก `?from=` ของ URL หน้านั้น ๆ เท่านั้น — ไม่จำข้ามหน้า/ข้าม session
 * `/sign-in` เปล่า ๆ = โลโก้แบ่งเบาเดิมเสมอ, `/sign-in?from=msme` = โลโก้ร่วม
 * (เคยจำไว้ใน sessionStorage แล้วทำให้ `/sign-in` เปล่ายังติดโลโก้ร่วมค้างในแท็บเดิม)
 */
export function useCoBrand(): boolean {
  const [searchParams] = useSearchParams();
  return CO_BRAND_SITES.includes((searchParams.get("from") || "").toLowerCase());
}
